import {
    SAVE_LEAD,
    GET_LEAD_BY_ID,
    GET_LEAD,
    GET_LEAD_FILTER,
    GET_LEAD_ACTIVITY,
    GET_LEAD_ACTIVITY_BY_ID,
    SAVE_ACTIVITY,
    GET_LEAD_ACTIVITY_LIST,
    INSPECTION_CREATED,
    GET_CITY,
    INSPECTION_FORM,
    SEARCH_DEALER_MASTER,
    PENDING_LIST,
    LEAD_APPROVAL_ACTION,
    ADDRESS_APPROVAL_PENDING_LIST,
    ADDRESS_APPROVAL,
    ADDRESS_APPROVAL_PENDING_BY_ID, ADDRESS_UPDATE_LOGS
} from "./type";

const initialState = {
    lead:[],
    leadById:[],
    leadList:[],
    leadFilter:[],
    leadActivity:[],
    leadActivityById:[],
    saveLeadActivity:[],
    activityList:[],
    inspectionCreatedData: [],
    getCity: [],
    inspectionForm: [],
    searchMasterDealer: [],
    pendingListResponse: [],
    leadApprovalResponse: [],
    addressApprovalPendingListResponse: [],
    getLeadAddressPendingByIdResponse: [],
    leadAddressApprovalActionResponse: [],
    getAddressUpdateLogsResponse: [],
};

const Lead = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case SAVE_LEAD:
            return {
                ...state,
                lead: payload,
            };
        case GET_LEAD_BY_ID:
            return {
                ...state,
                leadById: payload,
            };
        case GET_LEAD:
            return {
                ...state,
                leadList: payload,
            };
        case GET_LEAD_FILTER:
            return {
                ...state,
                leadFilter: payload,
            };
        case GET_LEAD_ACTIVITY:
            return {
                ...state,
                leadActivity: payload,
            };
        case GET_LEAD_ACTIVITY_BY_ID:
            return {
                ...state,
                leadActivityById: payload,
            };
        case SAVE_ACTIVITY:
            return {
                ...state,
                saveLeadActivity: payload,
            };
        case GET_LEAD_ACTIVITY_LIST:
            return {
                ...state,
                activityList: payload,
            };
        case INSPECTION_CREATED:
            return {
                ...state,
                inspectionCreatedData: payload,
            }
        case GET_CITY:
            return {
                ...state,
                getCity: payload,
            }
        case INSPECTION_FORM:
            return {
                ...state,
                inspectionForm: payload,
            }
        case SEARCH_DEALER_MASTER:
            return {
                ...state,
                searchMasterDealer: payload,
            }
        case PENDING_LIST:
            return {
                ...state,
                pendingListResponse: payload,
            }
        case LEAD_APPROVAL_ACTION:
            return {
                ...state,
                leadApprovalResponse: payload,
            }
        case ADDRESS_APPROVAL_PENDING_LIST:
            return {
                ...state,
                addressApprovalPendingListResponse: payload,
            }
        case ADDRESS_APPROVAL:
            return {
                ...state,
                leadAddressApprovalActionResponse: payload,
            }
        case ADDRESS_APPROVAL_PENDING_BY_ID:
            return {
                ...state,
                getLeadAddressPendingByIdResponse: payload,
            }
        case ADDRESS_UPDATE_LOGS:
            return {
                ...state,
                getAddressUpdateLogsResponse: payload,
            }
        default:
            return {...state};
    }
};

export default Lead;